var path = 'js/components/preview-window/preview-window.template.html';
var html = "<div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-click=$dismiss()><span aria-hidden=true>×</span></button> <h4 class=modal-title>{{$ctrl.title | capitalize}} Door</h4> </div> <div class=modal-body> <img ng-src=data:image/jpeg;base64,{{$ctrl.image.data}} style=width:auto;height:auto;max-width:100%;max-height:100%> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/preview-window/preview-window.template.html
// module id = 164
// module chunks = 0